import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Form } from 'formik'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import Input from 'components/Form/Input'
import Button from 'components/Button'

function ChangePasswordForm ({ handleSubmit, isSubmitting, handleToggleModal, checks, showCancel = true }) {
  const { t } = useTranslation()

  const commonInputProps = {
    fullWidth: true,
    type: 'password',
    variant: 'outlined',
    hasPasswordViewer: true,
    inputProps: { maxLength: 64 },
    disabled: isSubmitting
  }

  const allChecksOk = checks.every(c => c.ok)
  const splitIndex = Math.ceil(checks.length / 2)
  const checksLeft = checks.slice(0, splitIndex)
  const checksRight = checks.slice(splitIndex)

  const renderCheckList = (items) => (
    <List dense disablePadding>
      {items.map(check => (
        <ListItem key={check.id} dense disableGutters>
          <ListItemIcon style={{ minWidth: 24 }}>
            {check.ok
              ? <CheckIcon style={{ color: '#2e7d32', fontSize: 18 }} />
              : <CloseIcon style={{ color: '#c62828', fontSize: 18 }} />}
          </ListItemIcon>
          <ListItemText
            primary={t(check.label)}
            primaryTypographyProps={{
              variant: 'caption',
              style: {
                color: check.ok ? '#2e7d32' : '#c62828',
                fontSize: '0.75rem',
                lineHeight: 1.35
              }
            }}
          />
        </ListItem>
      ))}
    </List>
  )

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item>
          <Grid container>
            <Grid item md={12} sm={12} xs={12}>
              <Input
                name="oldPassword"
                id="oldPassword"
                label={t('general.oldPassword')}
                {...commonInputProps}
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Input
                name="newPassword"
                id="newPassword"
                label={t('general.newPassword')}
                {...commonInputProps}
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Input
                name="newPasswordConfirmation"
                id="newPasswordConfirmation"
                label={t('general.newPasswordConfirmation')}
                {...commonInputProps}
              />
            </Grid>
            <Grid item md={12} sm={12} xs={12} style={{ marginTop: 16 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  {renderCheckList(checksLeft)}
                </Grid>
                <Grid item xs={12} sm={6}>
                  {renderCheckList(checksRight)}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                type="submit"
                disabled={isSubmitting || !allChecksOk}
                isLoading={isSubmitting}
              >
                {t('general.actions.save')}
              </Button>
            </Grid>
            {showCancel && (
              <Grid item>
                <Button
                  isText
                  underlined
                  variant="contained"
                  fontColor="#212529"
                  disabled={isSubmitting}
                  onClick={() => { handleToggleModal(false) }}
                >
                  {t('general.actions.cancel')}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Form>)
}

ChangePasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleToggleModal: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  checks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    ok: PropTypes.bool.isRequired
  })).isRequired,
  showCancel: PropTypes.bool
}

export default ChangePasswordForm
